export const MAX_IMAGES_LENGTH = 6;
export const INITIAL_IMG_INDEX = 0;
